import React, {Component} from 'react';
import {history} from '../../../../store';
import IgniteDataTable from '../../../common/datatable';

class PointsTransactionsList extends Component {
  render() {
    const columns = [
      {
        prop: 'customer-number',
        title: 'Customer Number',
        onClick(cell, row) {
          history.push(`/admin/outlets/${row.attributes['outlet-id']}/view`);
        }
      },
      {
        prop: 'transaction-date',
        title: 'Transaction Date'
      },
      {
        prop: 'points-pot',
        title: 'Points Pot'
      },
      {
        prop: 'value',
        title: 'Value'
      },
      {
        prop: 'description',
        title: 'Description'
      },
      {
        prop: 'user-id',
        title: 'User id'
      },
      {
        prop: 'name',
        title: 'Name'
      },
    ];
    return (
      <IgniteDataTable
        columns={columns}
        data={this.props.points_transactions}
        dataSize={this.props.paging.number * this.props.paging.size}
        hideId={false}
        pagination={{
          page: this.props.currentPage,
          sizePerPage: 20,
          onPageChange: this.props.onPageChange,
        }}
        remote
      />
    );
  }
}

export default PointsTransactionsList;



// WEBPACK FOOTER //
// ./src/components/admin/points/points-transactions/points-transactions-list.jsx